/**
 * @flow
 * @relayHash 5ef8a62aba1fb5c6fcfe2f3f66e8d1d9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VueSharePermissionList_viewer$ref = any;
export type VueSharePermissionListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  ownerTenantId?: ?string,
  guestTenantId?: ?string,
|};
export type VueSharePermissionListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: VueSharePermissionList_viewer$ref
  |}
|};
export type VueSharePermissionListQuery = {|
  variables: VueSharePermissionListQueryVariables,
  response: VueSharePermissionListQueryResponse,
|};
*/


/*
query VueSharePermissionListQuery(
  $first: Int
  $offset: Int
  $ownerTenantId: ID
  $guestTenantId: ID
) {
  viewer {
    ...VueSharePermissionList_viewer_2Seiy1
    id
  }
}

fragment VueSharePermissionList_viewer_2Seiy1 on Query {
  vueSharePermissions(first: $first, offset: $offset, ownerTenant: $ownerTenantId, guestTenant: $guestTenantId) {
    count
    edges {
      node {
        id
        createdAt
        updatedAt
        guestTenant {
          id
          name
        }
        ownerTenant {
          id
          name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ownerTenantId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "guestTenantId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VueSharePermissionListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "VueSharePermissionList_viewer",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "guestTenantId",
                "variableName": "guestTenantId"
              },
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "ownerTenantId",
                "variableName": "ownerTenantId"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "VueSharePermissionListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vueSharePermissions",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "guestTenant",
                "variableName": "guestTenantId"
              },
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "ownerTenant",
                "variableName": "ownerTenantId"
              }
            ],
            "concreteType": "VueSharePermissionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "VueSharePermissionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VueSharePermissionNode",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "guestTenant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TenantNode",
                        "plural": false,
                        "selections": (v4/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ownerTenant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TenantNode",
                        "plural": false,
                        "selections": (v4/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "VueSharePermissionListQuery",
    "id": null,
    "text": "query VueSharePermissionListQuery(\n  $first: Int\n  $offset: Int\n  $ownerTenantId: ID\n  $guestTenantId: ID\n) {\n  viewer {\n    ...VueSharePermissionList_viewer_2Seiy1\n    id\n  }\n}\n\nfragment VueSharePermissionList_viewer_2Seiy1 on Query {\n  vueSharePermissions(first: $first, offset: $offset, ownerTenant: $ownerTenantId, guestTenant: $guestTenantId) {\n    count\n    edges {\n      node {\n        id\n        createdAt\n        updatedAt\n        guestTenant {\n          id\n          name\n        }\n        ownerTenant {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '81d3df9605f2c07fcd55636f256ed5b4';
module.exports = node;
